'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var travelDocuments = (0, _reactIntl.defineMessages)({
    LETTER_OF_INVITATION_NOT_REQUIRED: {
        'id': 'formOverrides.travelDocuments.LETTER_OF_INVITATION_NOT_REQUIRED',
        'defaultMessage': 'I have verified with a consulate that I do not require a Letter of Invitation to apply for my visa / I do not require a visa for this destination'
    }
});

exports.default = travelDocuments;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOverrides/travelDocuments.js
// module id = 1387
// module chunks = 0